import { META_PIXEL_ID, isMetaPixelAllowedOnCurrentHost } from '../config/metaPixel';
import {
  logMetaPixelDebug,
  logMetaPixelDiag,
  scheduleMetaPixelFollowUpLogs,
} from './metaPixelDebug';

function dispatchPixelReady() {
  if (window.__daivMetaPixelReadyDispatched) return;
  window.__daivMetaPixelReadyDispatched = true;
  window.dispatchEvent(new CustomEvent('daiv-meta-pixel-ready'));
  logMetaPixelDebug('ready event dispatched');
}

function isPixelRegistered() {
  try {
    const pixels = window.fbq?.getState?.()?.pixels;
    return pixels?.some((p) => String(p.id) === String(META_PIXEL_ID));
  } catch {
    return false;
  }
}

/** HTML head snippet inits the pixel; React only verifies and emits ready for funnel hooks. */
export function ensureMetaPixelInit() {
  if (typeof window === 'undefined') return;
  if (!isMetaPixelAllowedOnCurrentHost()) {
    logMetaPixelDebug('init skipped — host not allowed', { host: window.location.hostname });
    return;
  }

  if (window.__daivMetaPixelInited || isPixelRegistered()) {
    window.__daivMetaPixelInited = true;
    if (typeof window.fbq === 'function') {
      window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    }
    logMetaPixelDebug('init skipped (already active from index.html)', {
      fromHtml: !!window.__daivMetaPixelInited,
      registered: isPixelRegistered(),
    });
    dispatchPixelReady();
    scheduleMetaPixelFollowUpLogs();
    return;
  }

  logMetaPixelDebug('init fallback (HTML snippet missing) — loading fbevents');
  window.__daivMetaPixelInited = true;

  if (!window.fbq) {
    const f = window;
    const b = document;
    const n = (f.fbq = function fbq() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement('script');
    t.async = !0;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(t, s);
  }

  window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
  logMetaPixelDebug('init + PageView queued', { pixelId: META_PIXEL_ID });
  dispatchPixelReady();
  scheduleMetaPixelFollowUpLogs();
}

/** SPA route change — standard track (single pixel on this site). */
export function trackMetaPageView() {
  if (typeof window !== 'undefined' && !isMetaPixelAllowedOnCurrentHost()) {
    logMetaPixelDebug('PageView skipped — host not allowed', { host: window.location.hostname });
    return;
  }
  if (typeof window === 'undefined' || !window.fbq) {
    logMetaPixelDebug('PageView skipped — fbq missing');
    return;
  }
  window.fbq('track', 'PageView');
  logMetaPixelDebug('SPA PageView track', { path: window.location.pathname });
}

export { logMetaPixelDiag };
